import React from 'react';

import {useStore} from 'effector-react';

import {useTranslation} from 'react-i18next';

import {ROUTES} from '@/app/routing';
import {$subscriptionPaymentPending, doFetchPaymentInvoice} from '@/entities/subscriptions/model';
import {SubscriptionStatusEnum} from '@/entities/subscriptions/types';
import {Button, ButtonVariant} from '@/shared/ui/Button';
import {Icon} from '@/shared/ui/Icon';

import {history} from '@shared/lib/history';

import * as S from './styled';

export const BannerButtons = ({status}: {status?: SubscriptionStatusEnum}) => {
    const subscriptionPaymentPending = useStore($subscriptionPaymentPending);
    const {t} = useTranslation();
    return (
        <>
            {status && status === SubscriptionStatusEnum.PAYMENT_PENDING && (
                <S.ButtonGroup>
                    <div>
                        <Button
                            size="sm"
                            style={{whiteSpace: 'nowrap'}}
                            variant={ButtonVariant.Outline}
                            isLoading={subscriptionPaymentPending}
                            onClick={() => doFetchPaymentInvoice()}
                        >
                            <Icon
                                name="download2"
                                width={16}
                                height={16}
                                style={{marginRight: 8}}
                            />
                            <span>{t('subscriptions.button.downloadInvoice')}</span>
                        </Button>
                    </div>
                    {/* <div>
                        <Button
                            size="sm"
                            style={{whiteSpace: 'nowrap'}}
                            variant={ButtonVariant.Outline}
                            isLoading={subscriptionPaymentPending}
                            onClick={() => cancelSubscription()}
                        >
                            {t('subscriptions.button.cancelPlan')}
                        </Button>
                    </div> */}
                </S.ButtonGroup>
            )}

            {status && status === SubscriptionStatusEnum.CANCELLED && (
                <div>
                    <Button
                        size="sm"
                        style={{whiteSpace: 'nowrap'}}
                        variant={ButtonVariant.Normal}
                        onClick={() => history.push(ROUTES.SUBSCRIPTIONS)}
                    >
                        {t('subscriptions.button.contactSupport')}
                    </Button>
                </div>
            )}

            {status && status === SubscriptionStatusEnum.INACTIVE && (
                <div>
                    <Button
                        size="sm"
                        style={{whiteSpace: 'nowrap'}}
                        variant={ButtonVariant.Normal}
                        onClick={() => history.push(ROUTES.SUBSCRIPTIONS)}
                    >
                        {t('subscriptions.button.viewPlans')}
                    </Button>
                </div>
            )}
        </>
    );
};
